module.exports = "https://coursera_assets.s3.amazonaws.com/images/ce9b2505bff18337fa99e6cc1ec762bf.jpg";